var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-wrapper"},[_c('div',{staticClass:"board-wrapper_scroll"},[_c('div',[_c('dv-scroll-board',{staticStyle:{"height":"36px","background-color":"none"},attrs:{"config":_vm.config}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }